import {
    HomeCareEthnicityEnum,
    HomeCareRacesEnum,
    HomeHealthEthnicityEnum,
    HomeHealthRacesEnum,
    HospiceHispanicEthnicitiesEnum,
    HospiceRacesEnum,
    PalliativeEthnicityEnum,
    PalliativeRacesEnum
} from "../../../enums/enums";

const raceIndexMapper = {
    // INDEX BASE MAPPING so after modifying any array, please modify others too.
    1: [
        HomeHealthRacesEnum.White,
        HomeHealthRacesEnum.BlackOrAfricanAmerican,
        HomeHealthRacesEnum.AmericanIndianorAlaskaNative,
        HomeHealthRacesEnum.OtherAsian,
        HomeHealthRacesEnum.AsianIndian,
        HomeHealthRacesEnum.Chinese,
        HomeHealthRacesEnum.Filipino,
        HomeHealthRacesEnum.Japanese,
        HomeHealthRacesEnum.Korean,
        HomeHealthRacesEnum.Vietnamese,
        HomeHealthRacesEnum.NativeHawaiian,
        HomeHealthRacesEnum.GuamanianOrChamorro,
        HomeHealthRacesEnum.Samoan,
        HomeHealthRacesEnum.OtherPacificIslander,
        HomeHealthRacesEnum.PatientUnableToRespond,
        HomeHealthRacesEnum.PatientDeclinesToRespond,
        HomeHealthRacesEnum.NoneOfTheAbove
    ],
    2: [
        HomeCareRacesEnum.White,
        HomeCareRacesEnum.AfricanAmerican,
        HomeCareRacesEnum.AmericanIndian,
        HomeCareRacesEnum.OtherAsian,
        HomeCareRacesEnum.AsianIndian,
        HomeCareRacesEnum.Chinese,
        HomeCareRacesEnum.Filipino,
        HomeCareRacesEnum.Japanese,
        HomeCareRacesEnum.Korean,
        HomeCareRacesEnum.Vietnamese,
        HomeCareRacesEnum.NativeHawaiian,
        HomeCareRacesEnum.Guamanian,
        HomeCareRacesEnum.Samoan,
        HomeCareRacesEnum.PacificIslander,
        null,
        null,
        null
    ],
    65536: [
        PalliativeRacesEnum.White,
        PalliativeRacesEnum.BlackOrAfricanAmerican,
        PalliativeRacesEnum.AmericanIndianOrAlaskaNative,
        PalliativeRacesEnum.Asian,
        PalliativeRacesEnum.Asian,
        PalliativeRacesEnum.Asian,
        PalliativeRacesEnum.Asian,
        PalliativeRacesEnum.Asian,
        PalliativeRacesEnum.Asian,
        PalliativeRacesEnum.Asian,
        PalliativeRacesEnum.NativeHawaiianOrOtherPacificIslander,
        PalliativeRacesEnum.Asian,
        PalliativeRacesEnum.NativeHawaiianOrOtherPacificIslander,
        PalliativeRacesEnum.NativeHawaiianOrOtherPacificIslander,
        null,
        null,
        null
    ],
    256: [
        HospiceRacesEnum.White,
        HospiceRacesEnum.BlackOrAfricanAmerican,
        HospiceRacesEnum.AmericanIndianOrAlaskanNative,
        HospiceRacesEnum.OtherAsian,
        HospiceRacesEnum.AsianIndian,
        HospiceRacesEnum.Chinese,
        HospiceRacesEnum.Filipino,
        HospiceRacesEnum.Japanese,
        HospiceRacesEnum.Korean,
        HospiceRacesEnum.Vietnamese,
        HospiceRacesEnum.NativeHawaiian,
        HospiceRacesEnum.GuamanianOrChamorro,
        HospiceRacesEnum.Samoan,
        HospiceRacesEnum.OtherPacificIslander,
        HospiceRacesEnum.PatientUnableToRespond,
        HospiceRacesEnum.PatientDeclinesToRespond,
        HospiceRacesEnum.NoneOfTheAbove
    ]
} as any;

export const raceIndexMapping = (fromSolution: any, toSolution: number, raceArray: any[]) => {
    const respArray = new Set();
    let newVal = null;
    raceArray?.forEach((value) => {
        newVal = raceIndexMapper[toSolution][raceIndexMapper[fromSolution].indexOf(value)];
        if (newVal) {
            respArray.add(newVal);
        }
    });
    return Array.from(respArray) as number[];
};

const ethnicityIndexMapper = {
    1: [
        HomeHealthEthnicityEnum.NoNotOfHispanicOrigin,
        HomeHealthEthnicityEnum.AnotherHispanicLatinoOrSpanishOrigin,
        HomeHealthEthnicityEnum.MexicanAmericanChicano,
        HomeHealthEthnicityEnum.Puerto,
        HomeHealthEthnicityEnum.Cuban,
        HomeHealthEthnicityEnum.PatientUnableToRespond,
        HomeHealthEthnicityEnum.PatientDeclinesToRespond
    ],
    2: [
        HomeCareEthnicityEnum.NotOfHispanic,
        HomeCareEthnicityEnum.AnotherHispanic,
        HomeCareEthnicityEnum.Mexican,
        HomeCareEthnicityEnum.PuertoRican,
        HomeCareEthnicityEnum.Cuban,
        null,
        null
    ],
    65536: [
        PalliativeEthnicityEnum.NotHispanicorLatino,
        PalliativeEthnicityEnum.HispanicorLatino,
        PalliativeEthnicityEnum.HispanicorLatino,
        PalliativeEthnicityEnum.HispanicorLatino,
        PalliativeEthnicityEnum.HispanicorLatino,
        null,
        null
    ],
    256: [
        HospiceHispanicEthnicitiesEnum.NoNotOfHispanicLatinoOrSpanishOrigin,
        HospiceHispanicEthnicitiesEnum.YesAnotherHispanicLatinoOrSpanishOrigin,
        HospiceHispanicEthnicitiesEnum.YesMexicanAmericanChicano,
        HospiceHispanicEthnicitiesEnum.YesPuertoRican,
        HospiceHispanicEthnicitiesEnum.YesCuban,
        HospiceHispanicEthnicitiesEnum.PatientUnableToRespond,
        HospiceHispanicEthnicitiesEnum.PatientDeclinesToRespond
    ]
} as any;

export const ethnicityIndexMapping = (fromSolution: any, toSolution: number, ethnicityArray: any[]) => {
    let respArray = new Set();
    let newVal = null;
    ethnicityArray?.forEach((value) => {
        newVal = ethnicityIndexMapper[toSolution][ethnicityIndexMapper[fromSolution].indexOf(value)];
        if (newVal) {
            respArray.add(newVal);
        }
    });
    return Array.from(respArray) as number[];
};
